/**
 * Meta-Menü / Drawer: feste Produktvariante direkt in den Warenkorb.
 *
 * Wichtig (Desktop Mega-Menü): Dawn `header-menu` erbt `DetailsDisclosure.onFocusOut` —
 * wenn `document.activeElement` nicht mehr im Panel liegt, schließt sich das Menü.
 * `button.disabled = true` entfernt den Fokus vom Button → Menü klappt sofort zu, Spinner weg.
 * Deshalb: kein disabled während des Requests, Busy-Flag + Fokus auf Panel halten.
 */
(function () {
  var MIN_SPINNER_MS = 560;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    MIN_SPINNER_MS = 0;
  }

  function afterNextPaint(fn) {
    requestAnimationFrame(function () {
      requestAnimationFrame(fn);
    });
  }

  function delay(ms) {
    return new Promise(function (resolve) {
      setTimeout(resolve, ms);
    });
  }

  /** Fokus in Mega-Menü / Mobil-Drawer halten, damit DetailsDisclosure nicht sofort schließt */
  function retainParentMenuFocus(form) {
    var headerMenu = form.closest('header-menu');
    if (headerMenu) {
      var panel = headerMenu.querySelector('.mega-menu__content');
      if (panel) {
        if (!panel.hasAttribute('tabindex')) {
          panel.setAttribute('tabindex', '-1');
        }
        try {
          panel.focus({ preventScroll: true });
        } catch (err) {
          /* ignore */
        }
      }
      return;
    }
    var menuDrawer = form.closest('#menu-drawer');
    if (menuDrawer) {
      var holder =
        menuDrawer.querySelector('.menu-drawer__navigation-container') ||
        menuDrawer.querySelector('.menu-drawer__inner-container') ||
        menuDrawer;
      if (!holder.hasAttribute('tabindex')) {
        holder.setAttribute('tabindex', '-1');
      }
      try {
        holder.focus({ preventScroll: true });
      } catch (err2) {
        /* ignore */
      }
    }
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM' || !form.classList.contains('drawer-meta-variant-card__form')) {
      return;
    }
    e.preventDefault();

    if (form.dataset.drawerVariantAtcBusy === '1') {
      return;
    }

    var btn = form.querySelector('.drawer-meta-variant-card__submit');
    if (!btn || btn.disabled) {
      return;
    }

    form.dataset.drawerVariantAtcBusy = '1';

    var wrap = form.querySelector('.drawer-meta-variant-card__submit-wrap');
    var label =
      btn.tagName === 'BUTTON' ? btn.querySelector('.drawer-meta-variant-card__btn-label') : null;
    var spinner = wrap
      ? wrap.querySelector('.loading__spinner')
      : btn.querySelector('.loading__spinner');
    var origText = label
      ? label.textContent.trim()
      : (btn.value || btn.textContent || '').trim();

    function setSubmitLabel(text) {
      if (btn.tagName === 'INPUT') {
        btn.value = text;
      } else if (label) {
        label.textContent = text;
      }
    }

    var spinnerShownAt = Date.now();

    retainParentMenuFocus(form);

    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('loading');
    if (spinner) {
      spinner.classList.remove('hidden');
    }

    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var formData = new FormData(form);

    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map(function (s) {
          return s.id;
        }).join(',')
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }

    var action = form.getAttribute('action') || '/cart/add';

    function stopLoadingVisual() {
      btn.classList.remove('loading');
      btn.removeAttribute('aria-busy');
      if (spinner) {
        spinner.classList.add('hidden');
      }
    }

    function releaseBusy() {
      form.dataset.drawerVariantAtcBusy = '';
    }

    /**
     * Mobil: Menü nach erfolgreichem ATC schließen (Warenkorb liegt sonst „dahinter“).
     * @param {boolean} [immediate] — true vor Redirect; sonst verzögert, damit der
     *   Warenkorb-Drawer/Overlay erst gemalt wird (vermeidet Header-„Durchschein“).
     */
    function closeMobileMenuDrawerIfNeeded(immediate) {
      if (!form.closest('#menu-drawer')) {
        return;
      }
      if (typeof window.closeMenuDrawer !== 'function') {
        return;
      }
      if (immediate) {
        window.closeMenuDrawer();
        return;
      }
      afterNextPaint(function () {
        afterNextPaint(function () {
          window.closeMenuDrawer();
        });
      });
    }

    afterNextPaint(function () {
      fetch(action, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript'
        },
        body: formData
      })
        .then(function (r) {
          if (!r.ok) throw new Error('cart error');
          return r.json();
        })
        .then(function (response) {
          if (response.status) {
            throw new Error(response.description || response.message || 'cart error');
          }

          var elapsed = Date.now() - spinnerShownAt;
          var remaining = Math.max(0, MIN_SPINNER_MS - elapsed);

          return delay(remaining).then(function () {
            return response;
          });
        })
        .then(function (response) {
          stopLoadingVisual();
          setSubmitLabel('Hinzugefügt!');

          afterNextPaint(function () {
            if (cart && typeof cart.renderContents === 'function') {
              if (cart.classList && cart.classList.contains('is-empty')) {
                cart.classList.remove('is-empty');
              }
              cart.renderContents(response);
              closeMobileMenuDrawerIfNeeded(false);
            } else if (window.routes && window.routes.cart_url) {
              closeMobileMenuDrawerIfNeeded(true);
              window.location.href = window.routes.cart_url;
            } else {
              closeMobileMenuDrawerIfNeeded(true);
              window.location.href = '/cart';
            }

            setTimeout(function () {
              setSubmitLabel(origText);
              releaseBusy();
            }, 2000);
          });
        })
        .catch(function (err) {
          console.error('[drawer-variant-atc]', err);
          stopLoadingVisual();
          setSubmitLabel(origText);
          releaseBusy();
        });
    });
  });
})();
